import { useQuery } from '@tanstack/react-query';
import { queryFn } from './queryFn';

export const getQueryKey = (noteId: string): [string, string] => [
  'NOTE',
  noteId,
];

/**
 * This hook can be used to fetch a note
 * @param {string} noteId required to fetch a note
 *
 * @returns {Object}
 *  - `data` an object which contains a Note
 *  - `status` a flag to indicate state of the request
 */
export const useNote = (noteId: string) => {
  return useQuery({
    enabled: !!noteId,
    queryFn,
    queryKey: getQueryKey(noteId),
    retry: 1,
    staleTime: 3600000,
  });
};
